.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding-bottom: var(--tuna-spacing-1);
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.heading {
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 600;
  margin: 0;
}

/* Read by screen readers, not shown: the chord under review, after the heading */
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.heading:focus-visible {
  outline: 2px solid var(--tuna-focus-ring, var(--tuna-palette-primary-main));
  outline-offset: 2px;
}

.why,
.listen,
.alsoIn {
  font-size: var(--tuna-typography-fontSize-sm);
  margin: 0;
}

.listen,
.alsoIn {
  color: var(--tuna-content-secondary, var(--tuna-palette-text-secondary));
}

.placeLink {
  font-size: inherit;
  vertical-align: baseline;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-1);
  flex-wrap: wrap;
}

/* Phone: actions stack full-width at 44px or more (Joni §8) */
@media (max-width: 599.95px) {
  .actions {
    flex-direction: column;
  }

  .actions > * {
    min-height: 44px;
    width: 100%;
  }
}
